import type { NavigateFunction } from "react-router-dom";

type BackNavigationState = {
    returnTo?: string;
    returnState?: unknown;
};

export const goBackOrGoHome = (
    navigate: NavigateFunction,
    restoreState?: BackNavigationState,
    fallbackPath = "/dashboard",
) => {
    if (restoreState?.returnTo) {
        navigate(restoreState.returnTo, {
            state: restoreState.returnState,
        });
        return;
    }

    if (window.history.length > 1) {
        navigate(-1);
        return;
    }

    navigate(fallbackPath);
};
